
module.exports = {
	status: 'ready',
	title: 'Pagination',
	notes: '',
	context: {
		items: [
			'Föregående',
			'1',
			'2',
			'3',
			'Nästa',
		]
	},
};
